import { Checkbox } from '@trackman/web-shared-components';
import styled from 'styled-components';
import { grey, lightgrey } from 'styles/Colors';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 79px;
`;

export const StrikeZoneCalculationWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.div`
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  line-height: 25.2px;
`;

export const Description = styled.div`
  font-family: Lato;
  font-size: 13px;
  line-height: 18.2px;
  color: ${grey};
`;

export const PlaneList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  width: 476px;
`;

export const PlaneWrapper = styled.div`
  border: 1px solid ${lightgrey};
  border-radius: 4px;
  padding: 12px 16px;
`;

export const PlaneHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const PlaneLabel = styled.div`
  font-family: Lato;
  font-size: 13px;
  font-weight: 700;
  line-height: 18.2px;
`;

export const PlaneDescription = styled.div`
  font-family: Lato;
  font-size: 12px;
  line-height: 16.8px;
  color: ${grey};
`;

export const StyledCheckbox = styled(Checkbox)`
  &&& {
    &.MuiFormControlLabel-root {
      height: unset;
      width: unset;
      margin: 0;
      align-items: flex-start;
    }
  }
`;

export const AdjustmentWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AdjustmentToggle = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 700;
  line-height: 16.8px;
  cursor: pointer;
`;

export const DualUnitWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EqualsSign = styled.span`
  font-family: Lato;
  font-size: 14px;
  color: ${grey};
`;

export const PlaneVisualization = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
`;

export const PlaneSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const PlaneSummaryTitle = styled.div`
  font-family: Lato;
  font-size: 13px;
  font-weight: 700;
  line-height: 18.2px;
`;

export const PlaneSummaryDescription = styled.div`
  font-family: Lato;
  font-size: 12px;
  line-height: 16.8px;
  color: ${grey};
`;
